import { AsyncPipe, CommonModule, NgOptimizedImage, NgTemplateOutlet } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { BrowserModule } from '@angular/platform-browser';
import { ScenarioRoutingModule } from '@app/scenarios/scenario-routing.module';
import { ScenariosFinderPageComponent } from '@app/scenarios/scenarios-finder-page/scenarios-finder-page.component';
import { ScenariosPriceListComponent } from '@app/scenarios/scenarios-price-list/scenarios-price-list.component';
import { ScenariosResultListContainerComponent } from '@app/scenarios/scenarios-result-list-container/scenarios-result-list-container.component';
import { ScenariosResultListComponent } from '@app/scenarios/scenarios-result-list/scenarios-result-list.component';
import { SearchScenariosFormContainerComponent } from '@app/scenarios/search-scenarios-form-container/search-scenarios-form-container.component';
import { SearchScenariosFormComponent } from '@app/scenarios/search-scenarios-form/search-scenarios-form.component';
import {
  AppShellComponent,
  ButtonComponent,
  CheckboxComponent,
  FormFieldComponent,
  FormFieldLabelDirective,
  IconButtonComponent,
  IconComponent,
  LayerComponent,
  SearchComponent,
  SearchInputDirective,
  SegmentedControlComponent,
  SegmentedControlOptionComponent,
  TileModule,
  ToggleComponent,
} from '@totalenergiescode/tds-angular';
import { ScenarioUnitFormComponent } from '@app/scenarios/scenario-unit-form/scenario-unit-form.component';
import { PricesChartComponent } from '@app/scenarios/chart/prices-chart/prices-chart.component';
import { MatTooltip } from '@angular/material/tooltip';
import { InfoIconTooltipComponent } from '@app/tooltips/info-icon-tooltip/info-icon-tooltip.component';
import { ChartMarkersComponent } from '@app/scenarios/chart/chart-markers/chart-markers.component';
import { MatDivider } from '@angular/material/divider';
@NgModule({
    imports: [
        TileModule,
        FormsModule,
        CommonModule,
        ReactiveFormsModule,
        LayerComponent,
        ButtonComponent,
        BrowserModule,
        SearchComponent,
        SearchInputDirective,
        NgTemplateOutlet,
        MatSort,
        MatSortHeader,
        MatTableModule,
        MatFormFieldModule,
        MatSelectModule,
        AppShellComponent,
        IconComponent,
        IconButtonComponent,
        CheckboxComponent,
        FormFieldComponent,
        FormFieldLabelDirective,
        AsyncPipe,
        MatPaginatorModule,
        LayerComponent,
        ScenarioRoutingModule,
        MatCheckboxModule,
        MatMenuModule,
        SegmentedControlComponent,
        SegmentedControlOptionComponent,
        ToggleComponent,
        MatDatepickerModule,
        MatRadioModule,
        MatTooltip,
        InfoIconTooltipComponent,
        NgOptimizedImage,
        ChartMarkersComponent,
        MatDivider,
        ScenariosFinderPageComponent,
        ScenariosResultListComponent,
        ScenariosResultListContainerComponent,
        SearchScenariosFormComponent,
        SearchScenariosFormContainerComponent,
        ScenariosPriceListComponent,
        ScenarioUnitFormComponent,
        PricesChartComponent,
    ],
    providers: [provideHttpClient(withInterceptorsFromDi()), provideNativeDateAdapter()],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    exports: [
        ScenarioUnitFormComponent,
    ],
})
export class ScenarioModule {}
